<template>
  <div>
    <fieldset class="c-filter__controls">
      <legend class="c-filter__legend">{{ this.$attrs.label }} <ToolTip
      v-if="this.$attrs.infoBoxText !== ''"
      :ttcontent="this.$attrs.infoBoxText"
    /></legend>
      <div
        class="c-filter__control"
        v-for="value in this.$attrs.values"
        :key="value.id"
      >
        <label
          class="c-input-control c-filter-foldout__input-control"
          :for="value.id"
        >
          <input
            :id="value.id"
            :value="value.id"
            type="checkbox"
            class="c-input-control__input u-visually-hidden"
            @change="onChange"
            v-model="checked"
          />
          <span class="c-input-control__indicator"></span>
          <span class="c-input-control__label">{{ value.label }}</span>
        </label>
      </div>
    </fieldset>
    
  </div>
</template>

<script>
import ToolTip from '@/components/Filter/ToolTip.vue'

export default {
  name: 'CheckboxFilter',
  components: { ToolTip },
  props: { selectedValue: Array },
  data() {
    return { checked: [] }
  },
  watch: {
    selectedValue: {
      handler(newValue) {
        this.checked = newValue
      },
      immediate: true,
    },
  },
  methods: {
    onChange(e) {
      const { id, checked } = e.target

      if (checked) {
        this.checked.push(id)
        this.$emit('onChanged', { add: Number(id) })
      } else {
        const index = this.checked.indexOf(id)

        this.checked.splice(index, 1)
        this.$emit('onChanged', { remove: Number(id) })
      }
    },
  },
}
</script>
